import { Grid, Paper, Typography } from "@mui/material";
import React from "react";
import MainMenu from "../../components/MainMenu";
import CourseDetails from "../../components/CoursesManagementComponent/CourseDetails";

const index = () => {
  return (
    <MainMenu>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3}>
            <CourseDetails />
          </Paper>
        </Grid>
      </Grid>
    </MainMenu>
  );
};

export default index;